export default __webpack_public_path__ + "static/media/Group_7453.cdc30dda.png";